import { US_COUNTRY_ID } from "app/services/countryServiceConst";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";

import type { ISelectedCountry } from "../redesigned-wizard/segment-wizard/types";

export const getPreferredCountry = (availableCountries: ISelectedCountry[], sid: string) => {
    const prefKey = SegmentsUtils.getSegmentsAnalysisPrefKey(sid);
    const pref = PreferencesService.get(prefKey);
    const preferredCountryId = pref?.country ? Number.parseInt(pref.country) : null;

    const preferredCountry =
        preferredCountryId && availableCountries.find((country) => country.id === preferredCountryId);

    const hasDefaultCountryAccess = availableCountries.find((country) => country.id === US_COUNTRY_ID);

    const defaultCountry = preferredCountry ?? hasDefaultCountryAccess ?? availableCountries[0];
    return defaultCountry;
};
